export default "__VITE_ASSET__DJV7fHKs__"